// https://scotch.io/tutorials/how-to-implement-a-custom-validator-directive-confirm-password-in-angular-2

import {Directive, forwardRef, Attribute, Input} from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '*[appValidateEqual][formControlName],*[appValidateEqual][formControl],*[appValidateEqual][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => EqualValidatorDirective), multi: true }
  ]
})
export class EqualValidatorDirective implements Validator {

  @Input('appValidateEqual') public appValidateEqual: AbstractControl;
  @Input('reverse') public reverse: boolean;

  constructor() {
  }

  validate(c: AbstractControl): { [key: string]: any } {
    // self value
    const v = c.value;

    // control vlaue
    const e = this.appValidateEqual;

    // value not equal
    if (e && v !== e.value && !this.reverse) {
      return {
        validateEqual: false
      };
    }

    // value equal and reverse
    if (e && v === e.value && this.reverse) {
      delete e.errors['appValidateEqual'];
      if (!Object.keys(e.errors).length) {
        e.setErrors(null);
      }
    }

    // value not equal and reverse
    if (e && v !== e.value && this.reverse) {
      e.setErrors({ validateEqual: false });
    }

    return null;
  }
}
